import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
// import logo from '../../images/logo_veribase.png';
// import logoedxlight from '../../images/logo_equitasdx_light.png';
// import logoedxdark from '../../images/logo_equitasdx_dark.png';
import logo from '../../images/logomark_fiducia.png';
import logoedxlight from '../../images/logo_fiducia_light.png';
import logoedxdark from '../../images/logo_fiducia_dark.png';

import styled from 'styled-components';

const AgreementContainer = styled.div`
  height: 100vh;
  background: white;
  color: #333;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const AgreementHeader = styled.header`
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`;

const Logo = styled.img`
  height: 32px;
  width: auto;
`;

const LogoEdx = styled.img`
  height: 24px;
  width: auto;
`;

const AgreementContent = styled.main`
  flex: 1;
  overflow-y: auto;
  max-width: 800px;
  margin: 0 auto;
  padding: 0.5rem 2rem;
  line-height: 1.6;
  width: 100%;
  box-sizing: border-box;
  background: white;
`;

const AgreementLayout = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  // Set white background for body and apply theme class
  useEffect(() => {
    document.body.style.background = 'white';
    document.body.className = theme;
    
    return () => {
      document.body.style.background = '';
      document.body.className = '';
    };
  }, [theme]);

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <AgreementContainer>
      <AgreementHeader>
        <LogoContainer onClick={handleLogoClick}>
          <Logo src={logo} alt="Veritas" />
          <LogoEdx 
            src={theme === 'dark' ? logoedxlight : logoedxdark} 
            alt="EquitasDX" 
          />
        </LogoContainer>
      </AgreementHeader>
      <AgreementContent>
        <Outlet />
      </AgreementContent>
    </AgreementContainer>
  );
};

export default AgreementLayout; 